<app-device-features-container
  actionButtonName="{{
    '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
  }}"
  [header]="header"
  [overlayType]="availableOverlays.HeatingCircuit"
  [heatingCircuitId]="circuitId"
  [deviceSelectId]="deviceSelectId"
  [isMoreActions]="heatingCircuitNameFeature$ | async | ready | executable: 'setName'"
>
  <div header class="flex flex-row gap-[4px]">
    <app-pill
      *ngIf="getPumpStatus() | async | ready as pumpStatus"
      type="{{ (pumpStatus | value2: 'status') === 'on' ? pillType.success : pillType.secondary }}"
    >
      <ng-container *ngIf="(pumpStatus | value2: 'status') === 'on'">
        {{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.PUMP_ON_CHIP' | translate }}
      </ng-container>
      <ng-container *ngIf="(pumpStatus | value2: 'status') === 'off'">
        {{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.PUMP_OFF_CHIP' | translate }}
      </ng-container>
    </app-pill>
    <ng-container *ngIf="devicesStore.isSelectedDeviceOBNG$ | async">
      <ng-container *ngrxLet="vcsOptimizationData$ as vcsOptimizationData">
        <app-pill
          class="room-channel"
          *ngIf="vcsOptimizationData"
          [type]="vcsOptimizationData?.type"
        >
          <span class="flex items-center">
            <span class="mr-1">{{ vcsOptimizationData?.message }}</span>
            <mat-icon [matTooltip]="vcsOptimizationData?.tooltip">{{
              vcsOptimizationData?.alertType
            }}</mat-icon>
          </span>
        </app-pill>
      </ng-container>
    </ng-container>
    <app-pill
      *ngIf="
        !(devicesStore.isSelectedDeviceOBNG$ | async) &&
        (isHeatingCircuitWithActiveSRCAndDevices$ | async)
      "
      [type]="pillType.success"
    >
      {{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.SRC_INDICATOR' | translate }}
    </app-pill>
    <ng-container *ngIf="(heatingZone$ | async | ready)?.properties?.active?.value === true">
      <ng-container *ngIf="heatingZoneDemand$ | async | ready as heatingZoneDemand">
        <ng-container *ngIf="heatingZoneDemand?.properties?.present?.value; else demandNotPresent"
          ><app-pill [type]="pillType.success">
            {{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_ZONES_HEATING' | translate }}
          </app-pill></ng-container
        >
        <ng-template #demandNotPresent
          ><app-pill [type]="pillType.secondary">
            {{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_ZONES_NO_DEMAND' | translate }}
          </app-pill></ng-template
        >
      </ng-container>
    </ng-container>
  </div>

  <app-optimization-recommendation
    *ngIf="getHCRecommendations(circuitId) | async as recommendations"
    [recommendationName]="getHCOptimizationSlug(circuitId)"
    data-at-cascade-hc-optimizations
    feature
    [title]="'+INSTALLATIONS.INSTALLATION.OPTIMIZATION_RECOMMENDATION.TILE_HEADER' | translate"
    [description]="
      '+INSTALLATIONS.INSTALLATION.OPTIMIZATION_RECOMMENDATION.HC_DESCRIPTION'
        | translate
          : {
              factorySettings: recommendations
            }
    "
  ></app-optimization-recommendation>

  <!-- heating.circuits.${circuitId}.operating.modes.active -->
  <app-feature-tile
    data-at-feature-tile-operating-mode
    *ngIf="operatingModesActive$ | async | ready as feature"
    feature
    label="{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.OPERATING_MODE.TITLE' | translate }}"
    value="{{ feature.properties?.value?.value | translateOperatingMode | dash }}"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <!-- heating.circuits.${circuitId}.operating.programs.active -->
  <app-feature-tile
    *ngIf="operatingProgramsActive$ | async | ready as feature"
    feature
    label="{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.PROGRAM' | translate }}"
    value="{{ feature.properties?.value?.value | translateOperatingProgram }}"
    [attr.data-feature]="feature.feature"
  >
  </app-feature-tile>

  <!-- heating.circuits.${circuitId}.temperature -->
  <app-feature-tile
    *ngIf="targetTemperature$ | async | ready as feature"
    feature
    data-at-heating-circuits-temperature
    label="{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.TARGET_TEMPERATURE_LABEL' | translate }}"
    [value]="
      (isTargetFlowTemperatureVisible$ | async)
        ? (feature | value2: featurePropertyKey.value) + ' ' + (feature | unit: 'value')
        : NO_VALUE
    "
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  >
  </app-feature-tile>

  <ng-container feature>
    <ng-container
      *ngIf="
        (heatingRegulation$ | async | ready | value2: featurePropertyKey.mode) !==
          'ConstantControlled' &&
        (heatingRegulation$ | async | ready | value2: featurePropertyKey.mode) !==
          'ConstantControlledWithExternalThermostat'
      "
    >
      <ng-container
        *ngIf="
          (installationDetailsStore.getSelectedGateway$ | async)?.gatewayType !==
          gatewayType.VitoconnectOpenTherm
        "
      >
        <!-- heating.circuits.${circuitId}.sensors.temperature.supply -->
        <app-feature-tile
          *ngIf="flowTemperature$ | async | ready as feature"
          label="{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_CURVE.FLOW' | translate }}"
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
          [attr.data-feature]="feature.feature"
          [error]="feature | error"
        >
        </app-feature-tile>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container more-menu>
    <button
      data-at-rename-heating-circuit
      mat-menu-item
      gtm="onOpen"
      gtmAction="Rename heating circuit"
      gtmCategory="heatingCircuitPanel"
      (click)="openRenameHeatingCircuitModal()"
    >
      <span>{{ 'EDIT_HEATING_CIRCUIT_NAME_MODAL.TITLE' | translate }}</span>
    </button>
  </ng-container>
</app-device-features-container>
